import { render, staticRenderFns } from "./VotingVoteList.vue?vue&type=template&id=65dd7152&"
import script from "./VotingVoteList.vue?vue&type=script&lang=js&"
export * from "./VotingVoteList.vue?vue&type=script&lang=js&"
import style0 from "./VotingVoteList.vue?vue&type=style&index=0&id=65dd7152&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports